import React from "react";
import ContactWithUs from "../../components/avanegarContacts";
import LandingPanel from "../../components/avanegarDemo";
import Footer from "../../components/avanegarFooter";
import AvanegarFeatures from "../../components/avanegarLandingFeatures";
import NavbarLanding from "../../components/avanegarLandingHeader";
import Questions from "../../components/avanegarQuestions";
import Usages from "../../components/avanegarUsages";
import Customers from "../../components/customers";
import HeroPic from "../../components/HeroPic";
import Hero from "../../components/landingHero";
import GlobalStyle from "./globalStyles";
import { Container, LandingContainer } from "./index.styled";
import ChatBot from "../../components/chatbot";

const AvanegarLanding = () => {
  return (
    <>
      <GlobalStyle />
      <LandingContainer>
        <Container>
          <NavbarLanding />
          <Hero />
        </Container>
        <HeroPic />
        <Container>
          <AvanegarFeatures />
        </Container>
        <Usages />
        <LandingPanel />
        <Customers />
        <Container>
          <Questions />
        </Container>
        <ContactWithUs />
        <Container>
          <Footer />
        </Container>
        <ChatBot/>
      </LandingContainer>
    </>
  );
};

export default AvanegarLanding;
